import { useConfigQuery } from "@hooks";

import * as Apis from "../api";

const useAccountsPayableQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default useAccountsPayableQuery;
